<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>検索結果</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="table-responsive" [style.max-height]="maxHeight" [style.min-height]="minHeight">
            <table mat-table [dataSource]="dataSource" matSort style="min-width: 1103px;" #sort1="matSort">
                <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 2em; width: 2em;">
                        対象</th>
                    <td mat-cell *matCellDef="let row" class=" text-center">
                        <mat-checkbox color="primary" (change)="$event ? selectionToggle(row) : null;"
                            [checked]="selection.isSelected(row)"
                            [disabled]="mode != MODE_APPROVE && row.kafusokuAmt != 0"
                            (dblclick)="$event?.stopPropagation()">
                        </mat-checkbox>
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="kouzaReceivemoneyyoteiYearmonthdate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 130px">口座入金予定年月日
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.kouzaReceivemoneyyoteiYearmonthdate | dateString }}</td>
                    <td mat-footer-cell *matFooterCellDef [attr.colspan]="2"
                        style="padding-left: 4em; padding-right: 1em;">
                        <mat-form-field appearance="fill" class="in-cell"
                            [ngClass]="{'text-highlight': confirmzumiKafusokuRuikei != 0}">
                            <mat-label>報告済過不足額（累計）</mat-label>
                            <input matInput readonly="true" value="{{ confirmzumiKafusokuRuikei | number }}"
                                class="font-color-display-only text-right" disabled>
                            <span matSuffix style="margin-left: .3em;">円</span>
                        </mat-form-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="rcvmnyKeitai">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 85px">入金形態</th>
                    <td mat-cell *matCellDef="let row">{{ row.rcvmnyKeitai }}</td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="kouzaRcvmnyFclt">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 140px">口座入金機関</th>
                    <td mat-cell *matCellDef="let row">{{ row.kouzaRcvmnyFclt }}</td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="rcvmnyNumber">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 90px">入金件数[件]</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.rcvmnyNumber | number }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                    </td>
                </ng-container>
                <ng-container matColumnDef="rcvmnyPlannedamount">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 105px">入金予定額[円]</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.rcvmnyPlannedamount | number }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                    </td>
                </ng-container>
                <ng-container matColumnDef="kouzaRcvmnyAmt">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 105px">口座入金額[円]</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.kouzaRcvmnyAmt | number }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                    </td>
                </ng-container>
                <ng-container matColumnDef="feeAmt">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 105px">手数料額[円]</th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.feeAmt | number }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                    </td>
                </ng-container>
                <ng-container matColumnDef="kafusokuAmt">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 130px">過不足額[円]</th>
                    <td mat-cell *matCellDef="let row" class="text-right"
                        [style.font-weight]="row.kafusokuAmt != 0 ? 'bold':'normal'">
                        {{ row.kafusokuAmt | number }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                        <mat-form-field appearance="fill" class="in-cell">
                            <mat-label>過不足額合計（表示分）</mat-label>
                            <input matInput readonly="true" value="{{ this.hyojiBalanceSum | number }}"
                                class="font-color-display-only text-right" disabled>
                            <span matSuffix style="margin-left: .3em;">円</span>
                        </mat-form-field>
                    </td>
                </ng-container>
                <ng-container matColumnDef="reportYearmonthdate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 80px">報告年月日</th>
                    <td mat-cell *matCellDef="let row">{{ row.reportYearmonthdate | dateString}}</td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="apprvYearmonthdate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width: 105px">承認年月日</th>
                    <td mat-cell *matCellDef="let row">{{ row.apprvYearmonthdate | dateString }}</td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsCol(false); sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCol(false)" class="clickable-mat-row"
                    (dblclick)="onDblClickRow(row,$event)" [style.background-color]="getBackgroudColor(row)"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumnsCol(true);sticky: true"></tr>
            </table>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center"
            *ngIf="true">
            <mat-card-actions class="btn_area_right">
                <button type="button" *ngIf="mode != MODE_APPROVE" (click)="onClickReport()" [disabled]="disableRegist"
                    mat-raised-button color="primary" class="btn">報告</button>
                <button type="button" *ngIf="mode == MODE_APPROVE" (click)="onClickApproval()"
                    [disabled]="disableRegist" mat-raised-button color="primary" class="btn">承認</button>
            </mat-card-actions>
        </div>
    </mat-card-content>
</mat-card>